import { format, formatDistance } from 'date-fns';
import { getCurrentLocale, getLocale, getLocales } from '@alk/locales';
export const ISODateFormat = 'yyyy-MM-dd';
export const ISOTimeFormat = 'HH:mm:ss.SSS';
export function formatDate(date, formatStr = 'P') {
    return format(date, formatStr, {
        locale: getLocales()[getLocale()],
    });
}
export function formatDatetime(date, formatStr = 'Pppp') {
    return format(date, formatStr, {
        locale: getLocales()[getLocale()],
    });
}
export function formatTime(date, formatStr = 'pp') {
    return format(date, formatStr, {
        locale: getLocales()[getLocale()],
    });
}
export function alkFormatDistance(date, baseDate) {
    return formatDistance(date, baseDate, {
        addSuffix: true,
        includeSeconds: false,
        locale: getLocales()[getLocale()],
    });
}
export const durationFromNow = (date) => alkFormatDistance(date, Date.now());
export const getLocaleFormat = () => getCurrentLocale().formatLong.date({ width: 'short' });
/**
 * @deprecated Use the ISO8601 interface and utils to do that.
 */
export function isStringDate(value) {
    return !isNaN(Date.parse(value));
}
/**
 *
 * ex: 90D, 3M, 5Y
 * you can also have negative dates ex: -90D, -3M, -5Y
 * @deprecated Use the Tenor interface and utils to do that.
 */
export function hasGenericDateFormat(value) {
    const genericDateRegex = /^-?([1-9][0-9]{1,3}|[0-9])[BCDMYW]$/i;
    return genericDateRegex.test(value);
}
/**
 *
 *  ex: YESTERDAY, TODAY, O/N, TN, SPOT
 * @deprecated Use the Tenor interface and utils to do that.
 */
export function hasDepositDateFormat(value) {
    // eslint-disable-next-line max-len
    const depositDatesRegex = /^((Y)|(YES)|(YTDY)|(YESTERDAY)|(T)|(TD)|(TDY)|(TOD)|(TODAY)|(TM)|(TOM)|(TOMORROW)|(TN)|(T\/N)|(ON)|(O\/N)|S|(SPT)|(SP)|(SPOT)|(CASH)|(SN)|(S\/N)|(SW)|(S\/W))$/i;
    return depositDatesRegex.test(value);
}
/**
 *
 * ex: 25DEC or 25-DEC or 25 DEC
 */
export function hasYearlessDateFormat(value) {
    // eslint-disable-next-line max-len
    const yearlessDateRegex = /^(0[1-9]|[1-2][0-9]|3[0-1])([- ]?)((JAN)|(FEB)|(MAR)|(APR)|(MAY)|(JUN)|(JUL)|(AUG)|(SEP)|(OCT)|(NOV)|(DEC))$/i;
    return yearlessDateRegex.test(value);
}
/**
 *
 * ex: JAN15 , JUL16
 */
export function hasListedDateFormat(value) {
    const listedDateRegex = /^((JAN)|(FEB)|(MAR)|(APR)|(MAY)|(JUN)|(JUL)|(AUG)|(SEP)|(OCT)|(NOV)|(DEC))([0-9][0-9])$/i;
    return listedDateRegex.test(value);
}
/**
 * ex: SUN,SAT
 */
export function hasDayOfWeekFormat(value) {
    const date = value.toString().toUpperCase();
    const dayOfTheWeekRegex = /^((MON(DAY)?)|(TUE(SDAY)?)|(WED(NESDAY)?)|(THU(RSDAY)?)|(FRI(DAY)?)|(SAT(URDAY)?)|(SUN(DAY)?))$/i;
    return dayOfTheWeekRegex.test(date);
}
/**
 * ex: OPEN
 */
export function hasOpenTypeDateFormat(value) {
    const openTypeDateRegex = /^(OPEN)$/i;
    return openTypeDateRegex.test(value);
}
/**
 * @deprecated Use the Tenor interface and utils to do that.
 */
export function hasSpecialDateFormat(value) {
    return (hasGenericDateFormat(value) ||
        hasDepositDateFormat(value) ||
        hasYearlessDateFormat(value) ||
        hasListedDateFormat(value) ||
        hasDayOfWeekFormat(value) ||
        hasOpenTypeDateFormat(value));
}
